import { GET_PLAN, UPDATE_PLAN } from './constants';

export function updatePlan(item, callbackSuccess, callbackError) {
  return { type: UPDATE_PLAN, item, callbackSuccess, callbackError };
}

export function getPlan(id, callbackSuccess, callbackError) {
  return { type: GET_PLAN, id, callbackSuccess, callbackError };
}
